module.exports = __webpack_public_path__ + "img/write-mail.0751055a.svg";